import { Dispatch, SetStateAction } from 'react'

import {
  ORDER_HISTORY_SEARCH_CONDITION_CLEAR,
  OrderHistorySearchCondition
} from '@/common/api/modules/orderHistory'
import { isSameSearchCondition } from '@/common/api/search'

import Button from '@/components/view/atoms/button/Button'
import TextField, { TextBoxSize } from '@/components/view/atoms/textfield/TextField'
import SearchConditionAreaContent from '@/components/view/layouts/area/SearchConditionAreaContent'
import SortButtonList from '@/components/view/layouts/button/SortButtonList'
import FormRow from '@/components/view/layouts/form/FormRow'
import DisclosureSortKeyword from '@/components/view/molecules/disclosure/DisclosureSortKeyword'

interface Props {
  condition: OrderHistorySearchCondition
  setCondition: Dispatch<SetStateAction<OrderHistorySearchCondition>>
}

const OrderHistorySearchConditionField = ({ condition, setCondition }: Props) => {
  const isDefault = isSameSearchCondition(condition, ORDER_HISTORY_SEARCH_CONDITION_CLEAR)

  return (
    <SearchConditionAreaContent>
      <FormRow gap={8} size={TextBoxSize.FULL} align='center'>
        <TextField
          type='search'
          size={TextBoxSize.FULL}
          value={condition.keyword ?? ''}
          onChange={(e) =>
            setCondition((c) => ({ ...c, page: 1, keyword: e.target.value || null }))
          }
          placeholder='受注番号、アイテムID、会員番号、訪問者IDで検索...'
        />
      </FormRow>
      <SortButtonList>
        <DisclosureSortKeyword
          setCondition={setCondition}
          label='受注日時'
          name='orderDatetime'
          currentValue={condition.orderDatetime}
          placeholder='例: 2025/01'
        />
        <DisclosureSortKeyword
          setCondition={setCondition}
          label='顧客特定番号'
          name='customerId'
          currentValue={condition.customerId}
          placeholder='部分一致'
        />
        <DisclosureSortKeyword
          setCondition={setCondition}
          label='受注番号'
          name='orderNumber'
          currentValue={condition.orderNumber}
          placeholder='部分一致'
        />
        <DisclosureSortKeyword
          setCondition={setCondition}
          label='アイテムID'
          name='itemId'
          currentValue={condition.itemId}
          placeholder='部分一致'
        />
        <Button
          color='secondary'
          disabled={isDefault}
          onClick={() => setCondition(ORDER_HISTORY_SEARCH_CONDITION_CLEAR)}
        >
          条件をリセット
        </Button>
      </SortButtonList>
    </SearchConditionAreaContent>
  )
}

export default OrderHistorySearchConditionField
